"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Highlights = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,13.0376384 20.8243997,14.0342631 20.5012949,14.9617784 L20.5,15 L20.4876786,15.000578 C19.2520062,18.4958532 15.9184405,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,4 C7.581722,4 4,7.581722 4,12 C4,16.418278 7.581722,20 12,20 C13.4053916,20 14.7261415,19.6376064 15.873901,19.0011683 L12,19 L12,18 L17.2903142,18.0011777 C18.2141034,17.186188 18.9482523,16.1612281 19.4180912,15.0009677 L12,15 L12,14 L19.7478729,14.0003581 C19.9124613,13.3610104 20,12.6907281 20,12 C20,11.6613564 19.9789588,11.3276273 19.9381123,11.0000487 L12,11 L12,10 L19.7481308,10.000644 C19.4619252,8.88827156 18.9424895,7.8695153 18.2450575,6.99960899 L12,7 L12,6 L17.2911617,5.99957012 C15.8809559,4.75509929 14.0286594,4 12,4 Z" })));
};
Highlights.displayName = 'Highlights';
exports.default = Highlights;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Highlights.js.map